import { Module } from "vuex";
import { NekoState } from "@/lib/vuex/typings";
import { LoginState } from "@/lib/keycloak/typings/LoginState";
import { Cabinet } from "@/lib/keycloak/typings/EmaSoftsToken";

function setCabinet(state: LoginState, cabinet: Cabinet | null) {
	if (!state?.token?.cabinets?.length) {
		return;
	}

	if (cabinet) {
		localStorage.setItem("cabinet", JSON.stringify(cabinet));
	} else {
		localStorage.removeItem("cabinet");
	}

	state.cabinet = cabinet;
}

function getCabinet() {
	const oldCabinetString = localStorage.getItem("cabinet");

	if (!oldCabinetString) {
		return null;
	}

	return JSON.parse(oldCabinetString) as Cabinet;
}

function getInitialState() {
	const state: LoginState = {
		authenticated: false,
		authenticating: false,
		currentUser: null,
		roles: [],
		cabinet: getCabinet(),
		token: null
	};

	return state;
}

export default {
	namespaced: true,

	state: getInitialState(),

	getters: {
		currentUser: state => state.currentUser,
		authenticated: state => state.authenticated,
		authenticating: state => state.authenticating,
		roles: state => state.roles,
		cabinets: state => state.token?.cabinets || [],
		cabinet: state => state?.cabinet,
		hasRoles: state => (rolesCheck: string[]) => {
			let canContinue = true;

			for (let i = 0; rolesCheck && canContinue && i < rolesCheck.length; i++) {
				canContinue = canContinue && state.roles?.findIndex(r => r === rolesCheck[i]) !== -1;
			}

			return canContinue;
		}
	},

	mutations: {
		setCurrentUser(state, currentUser) {
			state.currentUser = currentUser;
		},

		setAuthenticated(state, authenticated) {
			state.authenticated = authenticated;
		},

		setAuthenticating(state, authenticating) {
			state.authenticating = authenticating;
		},

		setRoles(state, roles) {
			state.roles = roles || [];
		},

		setToken(state, token) {
			state.token = token;

			if (!state || !state.token) {
				setCabinet(state, null);
				return;
			}

			if (state.token.cabinets?.length === 1) {
				setCabinet(state, state.token.cabinets[0]);
			} else {
				const oldCabinet = getCabinet();

				if (oldCabinet && state.token.cabinets.findIndex(c => c.id === oldCabinet.id) !== -1) {
					setCabinet(state, oldCabinet);
				} else {
					setCabinet(state, null);
				}
			}
		},

		setCabinet
	}
} as Module<LoginState, NekoState>;
